interface props {
  children: React.ReactNode;
}
export const Truncate: React.FC<props> = (props) => {
  return <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{props.children}</div>;
};
